import { api, createQueryHandler } from './base';
import { AdminUserDto } from '@repo/common-types';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    adminCheck: builder.query<AdminUserDto, void>({
      query: createQueryHandler('/v1/auth/admin', 'GET'),
      providesTags: ['User'],
    }),

    logout: builder.mutation({
      query: createQueryHandler('/v1/auth/logout', 'POST'),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useAdminCheckQuery, useLogoutMutation } = authApi;
